/**
 * The language a payment result page opens in. The edge functions send the language of the conversation as a two letter code
 * (`lang=es`); the application ships `en` and `es-CL` (`supportedLngs` in `src/i18n/index.ts`), so Spanish is `es-CL` and any
 * other code is passed on as is and falls back to English until its locale files exist (pt and fr are not shipped yet).
 */
export function paymentPageLanguage(code: string | null | undefined): string | null {
  const value = (code ?? '').trim().toLowerCase();
  if (!/^[a-z]{2}(-[a-z]{2})?$/.test(value)) return null;
  return value === 'es' ? 'es-CL' : value;
}
